import axios from 'axios'
import pageKeys from '../common/pagekeys'

export default {
    async saveFaceDescriptors(data) {
        try{            
            const response = await axios.post(`FaceAI/face-descriptors`, 
            {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.attendance_face_activation
                }
            })            
            return response
        }catch (error){
            console.log('axios saveFaceDescriptors error: ' + error)
            throw error
        }
    },  
    async saveFaceDescriptorsByUser(data, userId) {
        try{            
            const response = await axios.post(`FaceAI/face-descriptors/${userId}`, 
            {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.attendance_face_activation
                }
            })            
            return response
        }catch (error){
            console.log('axios saveFaceDescriptorsByUser error: ' + error)
            throw error
        }
    },  
    async getUserFaceDescriptors() {
        try{            
            const response = await axios.get(`FaceAI/face-descriptors`, {
                headers: {
                    'page_key': pageKeys.attendance_face_activation
                }
            })            
            return response
        }catch (error){
            console.log('axios getUserFaceDescriptors error: ' + error)
            throw error
        }
    },
    async getFaceDescriptorsByUser(userId) {
        try{            
            const response = await axios.get(`FaceAI/face-descriptors/${userId}`, {
                headers: {
                    'page_key': pageKeys.attendance_face_activation
                }
            })            
            return response
        }catch (error){
            console.log('axios getUserFaceDescriptors error: ' + error)
            throw error
        }
    },
    async getFaceAIStatus() {
        try{            
            const response = await axios.get(`FaceAI/activation-status`, {
                headers: {
                    'page_key': pageKeys.faceai_settings
                }
            })            
            return response
        }catch (error){
            console.log('axios getFaceAIStatus error: ' + error)
            throw error
        }
    },
    async deleteUserFaceDescriptor(userFaceDescriptorId) {
        try{            
            const response = await axios.post(`FaceAI/face-descriptors/delete/${userFaceDescriptorId}`, 
            {},
            {
                headers: {
                    'page_key': pageKeys.attendance_face_activation
                }
            })            
            return response
        }catch (error){
            console.log('axios deleteUserFaceDescriptor error: ' + error)
            throw error
        }
    },
    async deleteFaceDescriptorByUser(userFaceDescriptorId, userId) {
        try{            
            const response = await axios.post(`FaceAI/face-descriptors/delete/${userFaceDescriptorId}/${userId}`, 
            {},
            {
                headers: {
                    'page_key': pageKeys.attendance_face_activation
                }
            })            
            return response
        }catch (error){
            console.log('axios deleteFaceDescriptorByUser error: ' + error)
            throw error
        }
    },
    async getAuthorizedUsers() {
        try{            
            const response = await axios.get(`FaceAI/authorized-users`, {
                headers: {
                    'page_key': pageKeys.faceai_settings
                }
            })            
            return response
        }catch (error){
            console.log('axios getAuthorizedUsers error: ' + error)
            throw error
        }
    },
    async addAuthorizedUsers(data) {
        try{            
            const response = await axios.post(`FaceAI/authorized-user`, 
            {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.faceai_settings
                }
            })            
            return response
        }catch (error){
            console.log('axios addAuthorizedUsers error: ' + error)
            throw error
        }
    },
    async removeAuthorizedUsers(data) {
        try{            
            const response = await axios.post(`FaceAI/authorized-user/remove`, 
            {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.faceai_settings
                }
            })            
            return response
        }catch (error){
            console.log('axios addAuthorizedUsers error: ' + error)
            throw error
        }
    },
}